// Iter35 — Visible icon-only theme cycle button in the topbar.
// Cycles: dark → light → auto → dark. Tooltip shows the NEXT target.
import React, { useEffect, useState } from "react";
import { Sun, Moon, Monitor } from "lucide-react";
import { readStoredTheme, setTheme } from "../lib/theme";

const NEXT = { dark: "light", light: "auto", auto: "dark" };
const TOOLTIP = {
  dark: "Switch to Light mode",
  light: "Switch to Auto",
  auto: "Switch to Dark mode",
};

export const TopbarThemeButton = () => {
  const [current, setCurrent] = useState(readStoredTheme());

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "sitroom_theme") setCurrent(readStoredTheme());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const Icon = current === "dark" ? Sun : current === "light" ? Moon : Monitor;
  const handleClick = () => {
    const next = NEXT[current] || "dark";
    setCurrent(next);
    setTheme(next);
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={TOOLTIP[current]}
      title={TOOLTIP[current]}
      data-testid="topbar-theme-toggle"
      data-theme-current={current}
      className="flex items-center justify-center transition-colors"
      style={{
        width: 32, height: 32,
        borderRadius: "50%",
        background: "transparent",
        border: "1px solid var(--border-strong)",
        color: "var(--text)",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.background = "var(--bg3)")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
    >
      <Icon size={14} />
    </button>
  );
};
